import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import "./DietPlans.css";

import { getDietPlans, deleteDietPlan } from "../../services/dietPlanService";

export default function DietPlans() {
  const navigate = useNavigate();

  const [plans, setPlans] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      const data = await getDietPlans();
      setPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this diet plan?",
    );

    if (!confirmDelete) return;

    try {
      await deleteDietPlan(id);

      alert("Diet Plan Deleted Successfully");

      loadPlans();
    } catch (error) {
      console.error(error);
      alert("Failed to delete diet plan");
    }
  };

  const filteredPlans = plans.filter(
    (plan) =>
      plan.planName?.toLowerCase().includes(search.toLowerCase()) ||
      plan.goal?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <DashboardLayout>
      <div className="diet-container">
        <div className="diet-header">
          <div>
            <h1>Diet Plans</h1>

            <p>Create and manage diet plans for Premium members.</p>
          </div>

          <button
            className="add-plan-btn"
            onClick={() => navigate("/diet-plans/add")}
          >
            + Add Diet Plan
          </button>
        </div>

        <div className="search-box-container">
          <input
            type="text"
            placeholder="Search Diet Plan..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-wrapper">
          <table className="diet-table">
            <thead>
              <tr>
                <th>Plan Name</th>

                <th>Goal</th>

                <th>Breakfast</th>

                <th>Morning Snack</th>

                <th>Lunch</th>

                <th>Evening Snack</th>

                <th>Dinner</th>

                <th>Calories</th>

                <th>Protein</th>

                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredPlans.length > 0 ? (
                filteredPlans.map((plan) => (
                  <tr key={plan.id}>
                    <td>{plan.planName}</td>

                    <td>{plan.goal}</td>

                    <td>{plan.breakfast}</td>

                    <td>{plan.morningSnack}</td>

                    <td>{plan.lunch}</td>

                    <td>{plan.eveningSnack}</td>

                    <td>{plan.dinner}</td>

                    <td>{plan.calories}</td>

                    <td>{plan.protein}</td>

                    <td>
                      <button
                        className="edit-btn"
                        onClick={() => navigate(`/diet-plans/edit/${plan.id}`)}
                      >
                        Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(plan.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" style={{ textAlign: "center" }}>
                    No Diet Plans Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
